var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      attrs: {
        type: "text",
        "data-test-id": "refresh-button",
        disabled: _vm.disabled,
      },
      on: { click: _vm.onClick },
    },
    [
      _c("div", [
        _c("img", {
          staticClass: "refresh-icon",
          attrs: { src: _vm.refreshIcon },
        }),
        _vm._v(" "),
        _vm.showText
          ? _c(
              "span",
              {
                staticClass: "refresh-button",
                attrs: { "data-test-id": "refresh-button-text" },
              },
              [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }